import { api } from "./api";
import { toast } from "sonner";

export async function downloadBlob(url, filename, okMsg, errMsg, params) {
  try {
    const res = await api.get(url, { responseType: "blob", params });
    const href = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = href;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);
    if (okMsg) toast.success(okMsg);
    return true;
  } catch {
    if (errMsg) toast.error(errMsg);
    return false;
  }
}
